import { render } from "./HealthFile.vue?vue&type=template&id=78dc8bc6"
import script from "./HealthFile.vue?vue&type=script&lang=js"
export * from "./HealthFile.vue?vue&type=script&lang=js"

import "./HealthFile.vue?vue&type=style&index=0&id=78dc8bc6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__